<mat-accordion>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title> informacion estados</mat-panel-title>
    </mat-expansion-panel-header>
      <p class="alert-text text-warning text-center">
        <strong>'EN_PROCESO'</strong> → Solicitud en espera de ser gestionada. <br>
        <strong>'DEVOLUCION'</strong> → Solicitud con uno o más documentos devueltos por no cumplir lo requerido. <br>
        <strong>'DEVOLUCION_SUBSANADA'</strong> → Solicitud con documento corregido por usted a la espera de gestión. <br>
        <strong>'RECHAZADO'</strong> → Solicitud con problemas que no permiten hacer la correcta gestión. <br>
        <strong>'APROBADO_PARCIAL'</strong> → Solicitud que cumple parcialmente lo requerido. <br>
        <strong>'APROBADO'</strong> → Solicitud que cumple totalmente lo requerido. <br>
        <strong>'COMPLETADO_PARCIAL'</strong> → Solicitud que cumple parcialmente lo requerido. <br>
        <strong>'COMPLETADO'</strong> → Solicitud que cumple totalmente lo requerido. <br>
        <strong>'EN_VALIDACION_INTERNA'</strong> → Solicitud en revisión de un especialista. <br>
        <strong>'COMPLETADO_MANUAL'</strong> → Solicitud completada por un especialista.
      </p>
  </mat-expansion-panel>
</mat-accordion>
